module.exports = __webpack_public_path__ + "img/mono_25.508af180.png";